export default {
    getData(state) {
        return state.data;
    },
    getTotal(state) {
        return state.total;
    },


    getCancelReasons(state) {
        return state.cancelReasons;
    },

    getDetail(state) {
        return state.detail;
    },


};
